import React from 'react';
import Image from 'mui-image';
import { colors } from '../utils/theme';

interface RootineImageProps extends React.ComponentProps<typeof Image> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeMap = {
  sm: { width: 128, height: 128 },
  md: { width: 256, height: 256 },
  lg: { width: 383, height: 383 },
  xl: { width: 554, height: 554 },
};

const styles = {
  img: {
    border: `1px solid ${colors.greys.SUBDUED_GREY}`,
    borderRadius: 4,
    backgroundColor: colors.greys.BASE_WHITE,
  },
};

export const RootineImage = ({
  size,
  ...rest
}: RootineImageProps): JSX.Element => {
  const dimensions = size ? sizeMap[size] : {};

  return <Image {...rest} style={styles.img} {...dimensions} />;
};
